import { Component, inject, OnInit, signal } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { SocialScreeningService } from '../../services/social-screening/social-screening.service';
import { CreatorsComponent } from './molecules/creators/creators.component';
import { BriefDetailsComponent } from './molecules/brief-details/brief-details.component';
import { BriefManagementComponent } from './molecules/brief-management/brief-management.component';
import { ScreeningBriefDetailDto, ScreeningBriefResponseDto, ScreeningListResponseDto } from '../../common/general-types/social-screening.dto';

@Component({
  selector: 'app-screening-brief-results',
  standalone: true,
  imports: [CreatorsComponent, BriefDetailsComponent, BriefManagementComponent],
  templateUrl: './screening-brief-results.component.html',
  styleUrl: './screening-brief-results.component.css'
})
export class ScreeningBriefResultsComponent implements OnInit {

  /** Layout */
  selectedTab = signal<'creators' | 'brief-details' | 'brief-management'>('creators');
  /** Layout - END */

  /** Services */
  private route = inject(ActivatedRoute);
  private location = inject(Location);
  public socialScreeningService = inject(SocialScreeningService);
  /** Services - END */

  focussedScreeningBriefId = signal<string | undefined>(undefined);
  focussedScreeningBrief = signal<ScreeningBriefResponseDto | undefined>(undefined);

  focussedCreatorList = signal<ScreeningListResponseDto | undefined>(undefined);  

  ngOnInit(): void {
    this.focussedScreeningBriefId.set(this.route.snapshot.params['briefId']);
    if (this.focussedScreeningBriefId()) {
      this.getScreeningBrief();
    }
  }

  getScreeningBrief() {
    this.socialScreeningService.getScreeningBriefById(this.focussedScreeningBriefId()!).subscribe((brief: ScreeningBriefDetailDto) => {
      console.log('brief: ', brief);
      this.focussedScreeningBrief.set(brief.screeningBrief);
      this.focussedCreatorList.set(brief.creatorList);
    });
  }

  selectTab(tab: 'creators' | 'brief-details' | 'brief-management') {
    this.selectedTab.set(tab);
  }

  getTabClass(tab: 'creators' | 'brief-details' | 'brief-management') {
    return this.selectedTab() === tab ? 'bg-gray-200 text-gray-900 dark:bg-white/10 dark:text-gray-200' : 'text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200';
  }

  backToBriefs() {
    this.location.back();
  }
}
